<template>
  <div>
    <div>
      <h1 class="text-center">{{ title }}</h1>
      <img
        class="sign-loading m-auto"
        src="../assets/images/loader.gif"
        alt=""
      />
      <ul class="sign-steps">
        <li class="f-b">
          {{ steps[0] }}
          <span
            :class="{ done: loadingLevel >= 1 }"
            class="icon icon-check icon--s"
          >
            <div class="icon icon-check icon--s"></div>
          </span>
        </li>
        <li class="f-b">
          {{ steps[1] }}
          <span
            :class="{ done: loadingLevel >= 2 }"
            class="icon icon-check icon--s"
          >
            <div class="icon icon-check icon--s"></div>
          </span>
        </li>
        <li class="f-b">
          {{ steps[2] }}
          <span
            :class="{ done: loadingLevel >= 3 }"
            class="icon icon-check icon--s"
          >
            <div class="icon icon-check icon--s"></div>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignatureLoader",
  props: ["loadingLevel", "title", "steps"],
  components: {},

  mounted() {},
  methods: {}
};
</script>

<style lang="less" scoped>
.sign-loading {
  width: 100px;
}
ul.sign-steps {
  width: 450px;
  @media (max-width: 768px) {
    width: 100%;
  }
  margin: 0 auto;
  li {
    padding: 15px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  li:not(:last-child) {
    border-bottom: 1px solid #eeeeee;
  }
  span {
    display: none;
    margin-left: 15px;
    &.done {
      display: block;
    }
  }
}
</style>
